export default __webpack_public_path__ + "pgnv-assets/9ecf39c8dc6a56c6358dd4a031d0f50b.png";